import { ITermCourse } from '../../../interfaces/scheduler_interfaces';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { ITermCoursesDatasource } from '../datasources/term_courses_datasource';
import { ITermPlannedCoursesDatasource } from '../datasources/term_planned_courses_datasource';
import { ITermSectionTypesDatasource } from '../datasources/term_section_types_datasource';
import { SectionTypeFilters } from '../filters/section_type_filters';
import { CourseFilters } from '../filters/course_filters';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { SectionSwapServant } from '../../../swap/servants/section_swap_servant';
import { TermProgramInfoModel } from '../models/term_program_info_model';
import { SectionSwapModel } from '../../../swap/models/course_section_swap_model';
export class TermCourseQuery implements IQuery {
  get result() {
    return this._result;
  }
  private _result: {
    planned: ITermCourse[];
    unscheduled: ITermCourse[];
  };

  constructor(
    private ngSectionTypeFilters: SectionTypeFilters,
    private ngTermCoursesDatasource: ITermCoursesDatasource,
    private ngTermPlannedCoursesDatasource: ITermPlannedCoursesDatasource,
    private ngTermSectionTypesDatasource: ITermSectionTypesDatasource,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngSectionSwapServant: SectionSwapServant,
    private ngCourseFilters: CourseFilters,
    private $stateParams: ng.ui.IStateParamsService,
    private ngCourseSectionSwapModel: SectionSwapModel,
    private ngTermProgramInfoModel: TermProgramInfoModel
  ) {
    Query.registerQuery(
      this,
      ngTermCoursesDatasource,
      ngTermPlannedCoursesDatasource,
      ngCourseSectionSwapModel,
      ngTermSectionTypesDatasource,
      ngSectionsDatasource
    );
  }
  run() {
    const termInfo = this.ngTermProgramInfoModel.read().term;
    if (!termInfo) {
      this._result = {
        planned: [],
        unscheduled: []
      };
      return this;
    }

    const termPlannedCourses = this.ngCourseFilters.filterPlannedCourses(
      this.ngTermCoursesDatasource.metasource().derived(),
      termInfo.id
    );

    const unscheduled = this.ngCourseFilters.filterUnscheduledCourses(termPlannedCourses);
    const swapModel = this.ngCourseSectionSwapModel.read();
    const swapCourseId = swapModel.course;
    const invalidCourseID = -1;
    const hasFromCourseChosen = swapModel.course > invalidCourseID;
    const removeCourseFromUnscheduled = this.ngSectionSwapServant.isInSwapCourseMode() && hasFromCourseChosen;
    // While swapping a course, remove that course from the unscheduled courses list .
    if (removeCourseFromUnscheduled) {
      _4.remove(unscheduled, (course) => _4.isEqual(course.id, swapCourseId));
    }
    this._result = {
      planned: termPlannedCourses,
      unscheduled
    };

    return this;
  }
}

angular.module('capability-ng-scheduler').service('ngTermCourseQuery', TermCourseQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/queries/term_courses_query.ts